import {
  Button,
  Modal,
  Typography,
  Box,
  FormControl,
  Grid,
  useTheme,
  TextField,
  useMediaQuery
} from "@mui/material";
import React, { useState } from "react";
import { useAlert } from "react-alert";
import { useParams } from "react-router-dom";
import { Axios } from "../App";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const AddNewParticipant:React.FC = () => {
  const alert = useAlert();
  const { id } = useParams();
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [numberOfAdditionalGuests, setNumberOfAdditionalGuests] = useState(0);
  const [field1, setField1] = useState("");
  const [field2, setField2] = useState("");
  const [field3, setField3] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const saveNewParticipant = () => {
    Axios.post("participants/saveSingleParticipantByEventID.php", {
      id: id,
      name: name,
      note: note,
      numberOfAdditionalGuests: numberOfAdditionalGuests,
      field1: field1,
      field2: field2,
      field3: field3,
    })
      .then(({ data }) => {
        if (!data?.success) throw new Error(data?.message);
        alert.success("Mentve!");
      })
      .then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((e) => {
        console.error(e);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      });
  };

  return (
    <>
      <Grid item xs={12}>
        <Button
          variant="contained"
          fullWidth={matches}
          color="primary"
          onClick={handleOpen}
        >
          Ùj név hozzáadása
        </Button>
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Ùj név hozzáadása
          </Typography>
          <form style={{ lineHeight: "5rem", margin: "20px 0 0 0 " }}>
            <FormControl style={{ width: "100%" }}>
              <TextField
                id="name"
                name="name"
                type="text"
                label="Résztvevő neve"
                placeholder="Résztvevő neve"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                sx={{
                  width: "100%",
                }}
              />
            </FormControl>
            <FormControl style={{ width: "100%" }}>
              <TextField
                id="number_of_additional_guests"
                name="number_of_additional_guests"
                type="number"
                label="Hozott vendégek száma"
                placeholder="Hozott vendégek száma"
                variant="outlined"
                value={numberOfAdditionalGuests}
                onChange={(e) => setNumberOfAdditionalGuests(parseInt(e.target.value))}
                sx={{
                  width: "100%",
                }}
              />
            </FormControl>
            <FormControl style={{ width: "100%" }}>
              <TextField
                id="note"
                name="note"
                type="textarea"
                label="Megjegyzés"
                placeholder="Megjegyzés"
                variant="outlined"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                sx={{
                  width: "100%",
                }}
              />
            </FormControl>
            <FormControl style={{ width: "100%" }}>
              <TextField
                id="field1"
                name="field1"
                type="textarea"
                label="Mező 1"
                placeholder="Mező 1"
                variant="outlined"
                value={field1}
                onChange={(e) => setField1(e.target.value)}
                sx={{
                  width: "100%",
                }}
              />
            </FormControl>
            <FormControl style={{ width: "100%" }}>
              <TextField
                id="field2"
                name="field2"
                type="textarea"
                label="Mező 2"
                placeholder="Mező 2"
                variant="outlined"
                value={field2}
                onChange={(e) => setField2(e.target.value)}
                sx={{
                  width: "100%",
                }}
              />
            </FormControl>
            <FormControl style={{ width: "100%" }}>
              <TextField
                id="field3"
                name="field3"
                type="textarea"
                label="Mező 3"
                placeholder="Mező 3"
                variant="outlined"
                value={field3}
                onChange={(e) => setField3(e.target.value)}
                sx={{
                  width: "100%",
                }}
              />
            </FormControl>
            <Button
              onClick={saveNewParticipant}
              disabled={!name}
              variant="contained"
              color="primary"
              sx={{
                width: "100%",
              }}
            >
              Mentés
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
};

export default React.memo(AddNewParticipant);
